import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { BsGrid3X3GapFill } from "react-icons/bs";
import { CiGrid2H } from "react-icons/ci";
import { useDispatch, useSelector } from "react-redux";
import { getProductsAndServices } from "../../store/actions/productAndServiceDataAction";
import CatalogueCard from "./CatalogueCard";
import Filters from "./Filters";
import CatalogueDetails from "./CatalogueDetails";
import Loader from "../Shared/Loader";

const CatalogueGrid = () => {
  const [isGridView, setIsGridView] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [productServiceDetails, setProductServiceDetails] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  
  const handleOpen = (data) => {
    setProductServiceDetails(data)
    setShowPopup(true);
  };

  const handleClose = () => setShowPopup(false);

  const dispatch = useDispatch();
  const productsAndServicesData = useSelector(
    (state) => state.productsAndServicesData
  );
  const { productsAndServices } = productsAndServicesData;

  useEffect(() => {
    if (productsAndServices.length !== 0) {
      setGridData(productsAndServices);
      setFilteredData(productsAndServices);
      setIsLoading(false);
    }
  }, [productsAndServices]);

  const toggleView = (isGrid) => {
    setIsGridView(isGrid);
  };

  useEffect(() => {
    if (!productsAndServices?.length) {
      setIsLoading(true);
      const apiUrl = "/api/home/getProductAndServiceData";
      dispatch(getProductsAndServices(apiUrl));
    }
  }, [dispatch]);

  return (
    <>
      {isLoading ? <Loader /> : ''}
      <div className="d-flex justify-content-end mb-4">
        <div className="btn-group">
          <button
            className={`btn btn-sm ${
              isGridView ? "btn-primary" : "btn-outline-secondary"
            }`}
            onClick={() => toggleView(true)}
            aria-label="Grid view"
          >
            <BsGrid3X3GapFill className="fs-4" />
          </button>
          <button
            className={`btn btn-sm ${
              !isGridView ? "btn-primary" : "btn-outline-secondary"
            }`}
            onClick={() => toggleView(false)}
            aria-label="List view"
          >
            <CiGrid2H className="fs-4" />
          </button>
        </div>
      </div>

      <div className="row">
        <div className="col-md-3">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="position-sticky top-0"
          >
            <Filters
              productAndServiceData={gridData}
              onFilter={setFilteredData}
            />
          </motion.div>
        </div>
        <div className="col-md-9">
          <div className="row g-4">
            {filteredData.length > 0 &&
              filteredData.map((card) => (
                <div
                  className={`${
                    isGridView ? "col-12 col-md-6 col-lg-4" : "col-12"
                  }`}
                  key={card.id}
                >
                  <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.05 * card.id }}
                    variants={{
                      visible: { opacity: 1, y: 0 },
                      hidden: { opacity: 0, y: 20 },
                    }}
                    className="h-100"
                    onClick={() => handleOpen(card)}
                  >
                    <CatalogueCard
                      type={card.type}
                      name={card.name}
                      description={card.summary}
                      link={card.link}
                      documentLink={card.documentLink}
                      onClick={() => handleOpen(card)}
                    />
                  </motion.div>
                </div>
              ))}
          </div>
        </div>
      </div>
      {
        productServiceDetails &&
        <CatalogueDetails
          showPopup={showPopup}
          handleClose={handleClose}
          productServiceDetails={productServiceDetails}
          productsAndServicesFullData={productsAndServices}
        /> 
      }      
    </>
  );
};

export default CatalogueGrid;
